import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";

type TemperatureIconProps = Partial<SVGIconProps>;
const TemperatureIcon = (props: TemperatureIconProps) => {
  return (
    <SVGIcon {...props} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path d="M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z" />
    </SVGIcon>
  );
};

export default TemperatureIcon;
